var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { SvgIcon } from './SvgIcon';
export var IconDirectionality;
(function (IconDirectionality) {
    /**
     * The specified icon is left-to-right specific.
     */
    IconDirectionality["LeftToRight"] = "LeftToRight";
    /**
     * The specified icon is right-to-left specific.
     */
    IconDirectionality["RightToLeft"] = "RightToLeft";
    /**
     * The specified icon is applicable to left-to-right and right-to-left locales.
     */
    IconDirectionality["All"] = "All";
})(IconDirectionality || (IconDirectionality = {}));
export const createSvgIcon = (viewBox, direction, ...children) => {
    return React.forwardRef((props, ref) => {
        // exclude ref from props being passed to component to avoid collision with the ref type from forwardRef
        const { ref: refProp } = props, other = __rest(props, ["ref"]);
        let isDirectional = true;
        if ([IconDirectionality.All, IconDirectionality.RightToLeft].includes(direction)) {
            isDirectional = false;
        }
        return (_jsx(SvgIcon, Object.assign({ ref: ref, isDirectional: isDirectional, viewBox: viewBox }, other, { children: children.map((child, index) => {
                // add a key to each child to avoid a react warning
                return React.cloneElement(child, {
                    key: index
                });
            }) })));
    });
};
